export default "__VITE_ASSET__CLNyBTd$__"